module.exports = __webpack_public_path__ + "static/media/miner1.b2f9176a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Miner/miner1.png
// module id = 875
// module chunks = 0